
<button class="btn btn-outline" (click)="addEditSubs(null)">Добави замяна</button>
<button class="btn btn-outline" (click)="addFromRecipes()">Добави всички съставки</button>
<button class="btn btn-outline" (click)="removeSelected()">Премахни избраните</button>

<clr-modal [(clrModalOpen)]="openModal">
    <h3 class="modal-title">Опишете замяната</h3>
    <div class="modal-body" >

        <div class="clr-row">
            <div class="clr-col">
                <div class="card">
                    <div class="card-header">
                        Материал, който да се замени
                    </div>
                    <div class="card-block">
                        <div class="card-text">
                            <!-- <clr-datalist-container>
                                <label style="max-width:100%">Продукт</label>
                                <input size="80" clrDatalistInput [disabled]="editIndex != null" [(ngModel)]="substitution.source.productName" autocomplete="off"/>
                                <datalist>
                                    <option *ngFor="let item of products" [value]="item?.Name?.BG">{{item?.PartNumber}}</option>
                                </datalist>
                            </clr-datalist-container> -->

                            <clr-combobox-container>
                                <label style="max-width:100%">Продукт</label>
                                <clr-combobox 
                                [(ngModel)]="substitution.source.productName"
                                autocomplete="off"
                                (clrInputChange)="fetchSourceProducts($event)"
                                (clrOpenChange)="$event ? fetchSourceProducts() : null"
                                [clrLoading]="sourceLoadingProducts"
                                [disabled]="editIndex != null"
                                >
                                  <ng-container *clrOptionSelected="let prod">
                                    {{prod}}
                                  </ng-container>
                                  <clr-options>
                                    <clr-option *ngFor="let prod of sourceProducts" [clrValue]="prod.Name.BG">
                                        {{prod?.PartNumber}} / {{prod?.Name?.BG}}
                                    </clr-option>
                                  </clr-options>
                                </clr-combobox>
                              </clr-combobox-container>

                            <clr-input-container>
                                <label style="max-width:100%">Входно количество</label>
                                <input type="number" size="55" clrInput placeholder="Попълнете входно количество" [(ngModel)]="substitution.source.quantity" autocomplete="off" />
                              </clr-input-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="clr-row">
          <div class="clr-col">
              <div class="card">
                  <div class="card-header">
                      Нов материал
                  </div>
                  <div class="card-block">
                      <div class="card-text">
                          <!-- <clr-datalist-container>
                              <label style="max-width:100%">Продукт</label>
                              <input size="80" clrDatalistInput [disabled]="editIndex != null" [(ngModel)]="substitution.replace.productName" autocomplete="off"/>
                              <datalist>
                                  <option *ngFor="let item of products" [value]="item?.Name?.BG">{{item?.PartNumber}}</option>
                              </datalist>
                          </clr-datalist-container> -->

                          <clr-combobox-container>
                            <label style="max-width:100%">Продукт</label>
                            <clr-combobox 
                            [(ngModel)]="substitution.replace.productName"
                            autocomplete="off"
                            (clrInputChange)="fetchReplaceProducts($event)"
                            (clrOpenChange)="$event ? fetchReplaceProducts() : null"
                            [clrLoading]="replaceLoadingProducts"
                            [disabled]="editIndex != null"
                            >
                              <ng-container *clrOptionSelected="let prod">
                                {{prod}}
                              </ng-container>
                              <clr-options>
                                <clr-option *ngFor="let prod of replaceProducts" [clrValue]="prod.Name.BG">
                                    {{prod?.PartNumber}} / {{prod?.Name?.BG}}
                                </clr-option>
                              </clr-options>
                            </clr-combobox>
                          </clr-combobox-container>


                          <clr-datalist-container>
                            <label style="max-width:100%">Склад</label>
                            <input size="80" clrDatalistInput [disabled]="editIndex != null" [(ngModel)]="substitution.replace.storeName" autocomplete="off"/>
                            <datalist>
                                <option *ngFor="let item of storeOptions" [value]="item?.Name?.BG">{{item?.Code}}</option>
                            </datalist>
                        </clr-datalist-container>
                  
                          <clr-input-container>
                              <label style="max-width:100%">Количество</label>
                              <input type="number" size="55" clrInput placeholder="Попълнете количество" [(ngModel)]="substitution.replace.quantity" autocomplete="off" />
                            </clr-input-container>
                      </div>
                  </div>
              </div>
          </div>
        </div>



    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline" (click)="cancel()">Откажи</button>
        <button type="button" class="btn btn-primary" (click)="save()">Запиши</button>
    </div>                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
</clr-modal>


<clr-datagrid class="datagrid-compact" [(clrDgSelected)]="selectedSubstitution">

    <clr-dg-placeholder>Не са добавени замени</clr-dg-placeholder>
    <clr-dg-column [clrDgField]="'source.productCode'">Код</clr-dg-column>
    <clr-dg-column [clrDgField]="'source.productName'">Материал</clr-dg-column>
    <clr-dg-column [clrDgField]="'source.quantity'">Количество</clr-dg-column>
    <clr-dg-column [clrDgField]="'source.productName'">Замени с Код</clr-dg-column>
    <clr-dg-column [clrDgField]="'replace.productName'">Замени с материал</clr-dg-column>
    <clr-dg-column [clrDgField]="'replace.storeName'">Склад</clr-dg-column>
    <clr-dg-column [clrDgField]="'replace.quantity'">Количество</clr-dg-column>
  
    <clr-dg-row *clrDgItems="let substitude of substitudes" [clrDgItem]="substitude">
      <clr-dg-action-overflow>
          <button class="action-item" (click)="addEditSubs(substitude)">Редакция</button>
          <button class="action-item" (click)="removeSubstitude(substitude)">Премахване</button>
      </clr-dg-action-overflow>
      <clr-dg-cell>{{substitude.source.productCode}}</clr-dg-cell>
      <clr-dg-cell>{{substitude.source.productName}}</clr-dg-cell>
      <clr-dg-cell>{{substitude.source.quantity}} {{substitude.source.measure?.Code}}</clr-dg-cell>
      <clr-dg-cell>{{substitude.replace.productCode}}</clr-dg-cell>
      <clr-dg-cell>{{substitude.replace.productName}}</clr-dg-cell>
      <clr-dg-cell>{{substitude.replace.storeName}}</clr-dg-cell>
      <clr-dg-cell>{{substitude.replace.quantity}}  {{substitude.replace.measure?.Code}}</clr-dg-cell>
    </clr-dg-row>
<!-- 
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="10">
          <clr-dg-page-size [clrPageSizeOptions]="[10,20,50,100]">Технологии на страница</clr-dg-page-size>
          {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
          от {{pagination.totalItems}} технологии
      </clr-dg-pagination>
    </clr-dg-footer> -->
  </clr-datagrid>